import * as React from "react";
import { SVGProps } from "react";

const SvgComponent = ({
  backgroundFillColor,
  ...svgProps
}: { backgroundFillColor?: string } & SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    style={{
      isolation: "isolate",
    }}
    viewBox="0 0 1837.358 913.8"
    width={2449.811}
    height={1218.4}
    {...svgProps}
  >
    <g>
      <path fill="none" d="M0 0h1837.358v913.8H0z" />
      <path
        d="M205.9 894.2c-26.4-29.7-30.8-96.3-11.8-126.9 24.2-39.1 122.3-56.5 146.8-94.7 61.7-96.4-51.7-159.2 27.3-224.2 48.1-39.6 162.9-17.3 206.5-60.4 67.8-67.1 80.8-190.2 183-209.3 42.3-7.9 94.3-2.5 134.9 13 54.2 20.7 96.1 99.5 154.9 101.5 35.1 1.1 85.4-44.6 148.4-58 183.9-39.3 259.7 62.8 304.2 106.8 43.6 43.1 103.4 63.9 151.5 103.5 79 65 15 136.4 76.8 232.9 24.5 38.2 73.1 47 97.3 86 19.6 31.6 14.3 101.7-14.5 129.8H205.9Z"
        fill={backgroundFillColor ?? "#12B1B9"}
      />
      <path d="M42.6 531.2h578.5L664 891.4H85.5L42.6 531.2Z" fill="#C97B9E" />
      <path d="M578.5 913.8H0l42.9-382.6h578.5l-42.9 382.6Z" fill="#F7ADCB" />
      <path d="M562.4 901H18.7L59 541.5h543.7L562.4 901Z" fill="#FFF" />
      <path
        d="M95.1 537.3c-.8 6 4.3 9.9 8.8 12.1 2.3 1.2 3.2 4 2.1 6.3-.8 1.6-2.5 2.6-4.2 2.6q-1.1 0-2.1-.5c-9.9-5-15-12.9-13.9-21.7 1.2-9.2 9.1-17.4 18.8-19.5 9.3-2 17.8 2 23.3 11 .7 1.1.9 2.4.6 3.5h-9.4c-4.2-5.7-9.1-6.1-12.5-5.4-5.8 1.3-10.9 6.4-11.5 11.6ZM143.6 537.3c-.8 6 4.4 9.9 8.8 12.1 2.3 1.2 3.2 4 2.1 6.3-.8 1.6-2.5 2.6-4.2 2.6q-1 0-2.1-.5c-9.9-5-15-12.9-13.9-21.7 1.2-9.2 9.1-17.4 18.8-19.5 9.3-2 17.8 2 23.3 11 .7 1.1.9 2.4.6 3.5h-9.4c-4.2-5.7-9-6.1-12.5-5.4-5.8 1.3-10.9 6.4-11.5 11.6ZM192.1 537.3c-.8 6 4.4 9.9 8.8 12.1 2.3 1.2 3.3 4 2.1 6.3-.8 1.6-2.5 2.6-4.2 2.6q-1 0-2.1-.5c-9.9-5-15-12.9-13.9-21.7 1.2-9.2 9.1-17.4 18.8-19.5 9.3-2 17.8 2 23.4 11 .6 1.1.8 2.4.5 3.5h-9.4c-4.2-5.7-9-6.1-12.5-5.4-5.8 1.3-10.8 6.4-11.5 11.6ZM240.6 537.3c-.8 6 4.4 9.9 8.8 12.1 2.3 1.2 3.3 4 2.1 6.3-.8 1.6-2.4 2.6-4.2 2.6q-1 0-2-.5c-10-5-15.1-12.9-14-21.7 1.2-9.2 9.1-17.4 18.8-19.5 9.4-2 17.9 2 23.4 11 .6 1.1.8 2.4.5 3.5h-9.4c-4.1-5.7-9-6.1-12.5-5.4-5.8 1.3-10.8 6.4-11.5 11.6ZM289.1 537.3c-.8 6 4.4 9.9 8.8 12.1 2.3 1.2 3.3 4 2.1 6.3-.8 1.6-2.4 2.6-4.1 2.6q-1.1 0-2.1-.5c-10-5-15.1-12.9-13.9-21.7 1.1-9.2 9-17.4 18.8-19.5 9.3-2 17.8 2 23.3 11 .6 1.1.8 2.4.5 3.5h-9.4c-4.1-5.7-9-6.1-12.5-5.4-5.8 1.3-10.8 6.4-11.5 11.6ZM337.6 537.3c-.7 6 4.4 9.9 8.9 12.1 2.3 1.2 3.2 4 2 6.3-.8 1.6-2.4 2.6-4.1 2.6q-1.1 0-2.1-.5c-10-5-15.1-12.9-13.9-21.7 1.1-9.2 9-17.4 18.8-19.5 9.3-2 17.8 2 23.3 11 .6 1.1.8 2.4.5 3.5h-9.4c-4.1-5.7-9-6.1-12.5-5.4-5.8 1.3-10.8 6.4-11.5 11.6ZM386.1 537.3c-.7 6 4.4 9.9 8.9 12.1 2.3 1.2 3.2 4 2 6.3-.8 1.6-2.4 2.6-4.1 2.6q-1.1 0-2.1-.5c-10-5-15-12.9-13.9-21.7 1.1-9.2 9.1-17.4 18.8-19.5 9.3-2 17.8 2 23.3 11 .7 1.1.8 2.4.6 3.5h-9.5c-4.1-5.7-9-6.1-12.5-5.4-5.8 1.3-10.8 6.4-11.5 11.6ZM434.6 537.3c-.7 6 4.4 9.9 8.9 12.1 2.3 1.2 3.2 4 2.1 6.3-.9 1.6-2.5 2.6-4.2 2.6q-1.1 0-2.1-.5c-10-5-15-12.9-13.9-21.7 1.2-9.2 9.1-17.4 18.8-19.5 9.3-2 17.8 2 23.3 11 .7 1.1.8 2.4.6 3.5h-9.5c-4.1-5.7-9-6.1-12.5-5.4-5.7 1.3-10.8 6.4-11.5 11.6ZM483.1 537.3c-.7 6 4.4 9.9 8.9 12.1 2.3 1.2 3.2 4 2.1 6.3-.8 1.6-2.5 2.6-4.2 2.6q-1.1 0-2.1-.5c-9.9-5-15-12.9-13.9-21.7 1.2-9.2 9.1-17.4 18.8-19.5 9.3-2 17.8 2 23.3 11 .7 1.1.8 2.4.6 3.5h-9.5c-4.1-5.7-9-6.1-12.5-5.4-5.7 1.3-10.8 6.4-11.5 11.6ZM531.7 537.3c-.8 6 4.3 9.9 8.8 12.1 2.3 1.2 3.2 4 2.1 6.3-.8 1.6-2.5 2.6-4.2 2.6q-1.1 0-2.1-.5c-9.9-5-15-12.9-13.9-21.7 1.2-9.2 9.1-17.4 18.8-19.5 9.3-2 17.8 2 23.3 11 .7 1.1.9 2.4.6 3.5h-9.4c-4.2-5.7-9.1-6.1-12.5-5.4-5.8 1.3-10.9 6.4-11.5 11.6Z"
        fill="#C97B9E"
      />
      <path
        d="M303.4 867.3c-79.4 0-144-64.6-144-144s64.6-143.9 144-143.9c3.1 0 5.7 2.5 5.7 5.7 0 3.1-2.6 5.7-5.7 5.7-73.1 0-132.6 59.4-132.6 132.5s59.5 132.6 132.6 132.6 132.5-59.5 132.5-132.6c0-32.4-11.8-63.6-33.2-87.8-2.1-2.4-1.9-6 .4-8.1 2.4-2.1 6-1.8 8.1.5 23.3 26.3 36.1 60.2 36.1 95.4 0 79.4-64.5 144-143.9 144Z"
        fill="red"
        fillOpacity={0.57}
      />
      <path d="m621.4 531.2 17.7 157.7-57.6 201.3 39.9-359Z" fill="#A54474" />
      <path d="M1704.848 895H533.1V0h1171.748v895Z" fill="none" />
      <path
        d="M1515.639 420.005q77.737 173.853 83.098 175.002l-163.514 54.377-58.59-298.307q86.161-89.608 139.006 68.928Z"
        fill="#FFF"
      />
      <path
        d="M1478.877 554.416q1.532 35.026 9.574 339.461h-370.288l-26.052-360.905-55.143 16.466c2.298-7.276-10.339-85.778 6.51-131.348 17.998-48.25 155.856-106.456 207.552-106.456 95.351 0 80.034-14.552 189.937 44.038 7.275 3.829 37.91 194.532 37.91 198.744Z"
        fill="#022E6A"
      />
      <path
        d="M1242.988 310.868 1276.5 895l-173.667-1.123V323.505l140.155-12.637ZM1449.774 357.586q12.844-145.362 59.179 537.414h-113.419l-17.752-573.41q46.335 9.191 71.992 35.996Z"
        fill="#FFF"
      />
      <path
        d="M1092.111 567.819 1197.893 895l-105.782-1.123c-4.589-23.481-4.566-132.144 0-326.058Z"
        fill="#C9E3FF"
      />
      <path
        d="m1357.104 235.047 8.041 82.714-32.932 119.093q-56.675-71.992-86.927-120.625l15.7-82.714 96.118 1.532Z"
        fill="#EF9D8E"
      />
      <path
        d="M1266.73 231.217q.766-.383 112.967-3.446-13.02 47.484-20.679 61.27-26.805 48.633-91.139-53.611"
        fill="#170823"
      />
      <mask id="b" x="-200%" y="-200%" width="400%" height="400%">
        <rect
          x="-200%"
          y="-200%"
          width="400%"
          height="400%"
          style={{
            fill: "#fff",
          }}
        />
        <path d="M1328.383 884.125 1192.824 544.46l28.72-55.526-48.633-46.719q26.04-121.008 27.954-128.283" />
      </mask>
      <path
        d="M1328.383 884.125 1192.824 544.46l28.72-55.526-48.633-46.719q26.04-121.008 27.954-128.283"
        fill="none"
      />
      <path
        d="M1328.383 884.125 1192.824 544.46l28.72-55.526-48.633-46.719q26.04-121.008 27.954-128.283"
        fill="none"
        mask="url(#b)"
        vectorEffect="non-scaling-stroke"
        strokeWidth={0.8}
        stroke="#022E6A"
      />
      <mask id="c" x="-200%" y="-200%" width="400%" height="400%">
        <rect
          x="-200%"
          y="-200%"
          width="400%"
          height="400%"
          style={{
            fill: "#fff",
          }}
        />
        <path d="M1406.119 328.483q0 2.681 33.699 109.903l-33.316 35.23 38.677 24.508-63.185 393.659" />
      </mask>
      <path
        d="M1406.119 328.483q0 2.681 33.699 109.903l-33.316 35.23 38.677 24.508-63.185 393.659"
        fill="none"
      />
      <path
        d="M1406.119 328.483q0 2.681 33.699 109.903l-33.316 35.23 38.677 24.508-63.185 393.659"
        fill="none"
        mask="url(#c)"
        vectorEffect="non-scaling-stroke"
        strokeWidth={1}
        stroke="#022E6A"
      />
      <path
        d="M1591.078 584.668q72.758 97.649 46.335 172.322-26.422 74.289-395.573-18.381l186.49-111.435 57.823-2.298 47.101-17.615 57.824-22.593Z"
        fill="#EF9D8E"
      />
      <path
        d="M1558.145 512.676q111.435 172.704 85.012 246.994-26.422 74.29-401.317-21.061l186.49-111.435 57.823-2.298 39.826-29.869 32.166-82.331Z"
        fill="#FFF"
      />
      <path
        d="m1265.965 745.119 124.071-70.461 100.712-45.186-146.664 130.964-78.119-15.317Z"
        fill="#C9E3FF"
      />
      <path
        d="M1390.419 685.763Q1114.322 891.4 1036.968 821.706q-67.014-105.691-9.19-364.556l137.091 48.633q-2.297 124.454 6.893 121.391 8.808-3.064 220.572-7.276 35.996-43.272 98.414 9.574l-100.329 56.291Z"
        fill="#EF9D8E"
      />
      <path
        d="M1240.691 781.115c-78.119 42.123-165.429 75.055-203.723 40.591q-67.014-105.691-9.19-364.556l52.845 18.764c-1.532 1.532-2.298 3.829-2.68 6.51-4.213 42.506-12.637 84.629-15.318 127.518-2.298 37.145-1.915 79.268 16.466 112.583 29.869 52.846 97.649 66.631 153.558 59.738q3.829-.383 8.042-1.148Z"
        fill="#F4786C"
      />
      <path
        d="M986.038 722.525c22.21-106.456 19.147-329.708 88.075-392.127 31.401-28.72 90.756-16.849 116.03-13.02 13.403 1.915-25.274 132.113-27.954 145.516l12.637 163.514-188.788 96.117Z"
        fill="#FFF"
      />
      <path
        d="M1375.867 127.058c-3.063 4.213-7.275 9.191-12.254 11.106-9.956 3.829-33.315 9.19-44.803.765-10.722-8.424-20.679-8.424-24.125-6.127l-24.891 79.651 1.915.766-1.532 3.064-25.274-13.403 15.317 4.978q0-.383-.382-.766l4.212 2.298q-2.298-2.298-4.595-3.83c-18.381-58.206-29.487-87.309-16.467-104.158 11.871-45.57 47.102-42.506 96.117-46.719 64.717-6.892 58.59 56.292 42.889 78.885-2.68 4.979-1.914-9.573-6.127-6.51Zm-117.178 79.651 1.149.383q0-.766-.383-1.532c-2.298-1.148-4.596-2.297-6.51-2.68l5.744 3.829Z"
        fillRule="evenodd"
        fill="#170823"
      />
      <path
        d="M1272.857 125.527c28.721-19.147 32.55-4.978 50.165 1.531 11.105 4.213 29.869 9.574 40.208 6.127q9.957-3.446 17.233-17.232c14.551 88.842 4.595 159.685-15.701 166.195-27.954 9.19-52.845 1.149-63.567-6.51-20.679-14.552-26.806-27.572-31.401-35.23-2.681-3.83-32.933 1.149-27.572-27.189 3.83-21.061 14.935-13.785 20.296-8.424 1.532 1.531 4.212.765 4.978-1.149 4.978-12.254-15.7-64.334 5.361-78.119Z"
        fill="#EF9D8E"
      />
      <path d="m1246.818 210.922 16.083 11.871" />
      <path
        d="M1306.173 177.606c-4.978 3.447 2.68-12.637 9.956-14.934 7.276-1.915 14.169 1.531 16.084 7.658q-13.403-1.531-26.04 7.276ZM1352.891 172.628c2.681-6.51 10.722-8.042 18.381-4.978 5.361 3.829 8.425 12.637 1.532 9.956q-4.212-1.532-19.913-4.978Z"
        fill="#170823"
      />
      <path
        d="m1344.084 194.072 8.041 22.594c.383.383 0 .766-.383 1.148l-9.956.383c-.383 0-.766-.383-.383-.765l1.532-23.36c0-.765.766-.765 1.149 0Z"
        fill="#D05346"
      />
      <path
        d="M1329.915 199.816c0 3.447-1.149 6.51-2.681 6.51-1.914 0-3.063-3.063-3.063-6.51 0-3.446 1.149-6.127 3.063-6.127 1.532 0 2.681 2.681 2.681 6.127ZM1356.338 200.199c0 3.447-1.149 6.51-2.681 6.51s-3.063-3.063-3.063-6.51c0-3.446 1.531-6.127 3.063-6.127 1.532 0 2.681 2.681 2.681 6.127Z"
        fill="#170823"
      />
      <path
        d="M1347.913 245.386q-11.105 1.149-24.125-18.381 4.595.383 37.911-.383-2.681 17.998-13.786 18.764Z"
        fill="#FFF"
      />
      <path
        d="M1288.941 263.767v-45.57l53.994-14.551 45.569 9.573q4.213 49.782-6.127 62.419c-27.571 34.847-98.031 0-93.436-11.871Z"
        fill="#FFF"
      />
      <mask id="d" x="-200%" y="-200%" width="400%" height="400%">
        <rect
          x="-200%"
          y="-200%"
          width="400%"
          height="400%"
          style={{
            fill: "#fff",
          }}
        />
        <path d="m1257.54 200.199 45.952 26.423" />
      </mask>
      <path
        mask="url(#d)"
        vectorEffect="non-scaling-stroke"
        strokeWidth={1}
        stroke="#FFF"
        d="m1257.54 200.199 45.952 26.423"
      />
      <mask id="e" x="-200%" y="-200%" width="400%" height="400%">
        <rect
          x="-200%"
          y="-200%"
          width="400%"
          height="400%"
          style={{
            fill: "#fff",
          }}
        />
        <path d="m1295.068 266.065-41.74-27.572" />
      </mask>
      <path
        mask="url(#e)"
        vectorEffect="non-scaling-stroke"
        strokeWidth={1}
        stroke="#FFF"
        d="m1295.068 266.065-41.74-27.572"
      />
      <path
        d="m1174.826 626.408 174.236-26.04 25.274 111.435Q1115.47 891.4 1043.478 844.682c-33.315-21.827-52.079-122.157-50.164-143.601q1.531-21.828 181.512-74.673Z"
        fill="#FFF"
      />
      <path
        d="M982.974 423.835q13.786-24.508 41.74-.766 27.955 23.742 97.266 140.155l-67.397 127.135-71.609-266.524Z"
        fill="#70A3F6"
      />
      <path
        d="M856.605 273.34c-39.442-48.633-32.933-164.663 98.798-131.347 29.869 7.276 52.079 15.317 67.397 44.038 5.744 10.339 6.127 27.571-3.83 62.035l-80.799 134.028q-57.058-78.119-81.566-108.754Z"
        fill="#1D0E2E"
      />
      <path
        d="M877.284 172.628c.766 8.425-5.361 16.083-13.02 19.53-7.276 3.446-16.084 3.446-24.125 2.297-10.722-1.531-21.062-5.361-29.103-12.637-7.659-7.275-12.254-18.381-10.34-29.103 2.298-10.339 10.723-18.764 19.147-25.274 3.829-3.063 7.659-6.127 12.254-7.658 13.02-4.596 27.954 2.297 35.996 13.019 3.064 3.83 5.361 8.425 6.51 13.02 3.064 14.169-4.978 28.721-12.637 40.975"
        fill="#1D0E2E"
      />
      <path
        d="M992.931 186.414c10.339 4.212 42.123 20.295 36.379 84.629-6.127 70.46-45.187 58.206-55.143 60.121q2.68 23.359 25.273 101.478 0 128.284-113.349-4.212 14.935-28.721 16.084-53.611c1.914-45.57-3.83-74.29-5.745-82.715-.765-3.063-1.914-8.041-4.595-7.276-11.871 3.83-26.039-20.295-16.083-34.464 9.956-14.169 23.359-7.659 28.72-4.212 1.149.766 3.064 0 3.447-1.149 34.847-69.695 76.204-61.653 85.012-58.589Z"
        fill="#EE9387"
      />
      <path
        d="m984.506 372.138-36.762-45.569 27.571 4.595 9.191 40.974Z"
        fill="#DB6761"
      />
      <path
        d="M804.909 448.725q22.976-29.486 50.93-40.974 6.893-4.595 39.826-8.424l95.351 75.055q6.893-5.361 4.212-58.589c-1.914 4.978 63.951 85.395 73.524 131.347 8.425 43.272 23.742 329.505 23.742 346.737H728.495q57.267-386.945 76.414-445.152Z"
        fill="#70A3F6"
      />
      <path
        d="m860.434 473.233 71.61 420.644H728.495q25.866-183.989 48.076-278.191c34.848-144.75 83.098-106.457 83.863-142.453Z"
        fill="#4C88E0"
      />
      <path
        d="M901.409 264.15q-11.871-27.572-21.445-5.361l21.445 5.361Z"
        fill="#DB6761"
      />
      <path
        d="M987.569 294.785q-8.424 1.532-15.317-12.254l28.72.383q-4.978 10.722-13.403 11.871Z"
        fill="#FFF"
      />
      <path
        d="M995.611 273.34c.766 1.532-.383 3.447-1.915 3.447h-9.956l2.681-18.764 9.19 15.317Z"
        fill="#DB6761"
      />
      <path d="M960.764 239.642c-3.447 1.915 1.915-7.659 6.51-8.425 4.212-.766 10.339 0 10.339 3.447-.383 4.212-9.19 0-16.849 4.978ZM998.675 235.047c-.383-5.361 5.361-5.361 9.573-4.213 4.212 1.532 8.425 11.488 5.361 9.191-6.893-5.744-14.934-1.149-14.934-4.978ZM973.018 251.896c1.532 0 2.68 2.68 2.68 6.127 0 3.063-1.531 5.744-3.063 5.744-1.532 0-2.681-2.681-2.681-6.127 0-3.064 1.532-5.744 3.064-5.744ZM999.058 251.13c1.531 0 2.68 2.298 2.68 5.744-.383 3.064-1.532 5.361-3.063 5.361-1.532 0-2.681-2.297-2.681-5.744 0-3.063 1.532-5.361 3.064-5.361Z" />
      <path
        d="M1004.802 146.971c4.978 10.722 15.317 109.137-55.143 39.443-.383 6.127-9.574 55.143-39.443 32.932q6.51-43.655 17.998-43.655c-4.595-8.041-62.036 13.786-49.782.766 38.294-41.357 107.606-71.609 126.37-29.486Z"
        fill="#1D0E2E"
      />
      <path
        d="M855.839 410.432q82.715 20.295-24.125 237.038l-145.133-81.566q86.544-175.768 169.258-155.472Z"
        fill="#70A3F6"
      />
      <path d="M956.935 596.539H896.43v-23.742h60.505v23.742Z" fill="#F4FDF8" />
      <path
        d="m1013.609 522.249-34.464-4.595v-.383c1.532-8.807 9.573-14.934 18.381-13.786l2.297.383c8.808 1.149 15.318 9.191 13.786 18.381Zm-12.637-9.956c.383-1.915-.766-3.829-2.68-4.212-2.298 0-3.83 1.148-4.213 3.063-.383 1.915 1.149 3.829 3.064 4.212 1.915.383 3.829-1.148 3.829-3.063Z"
        fillRule="evenodd"
        fill="#4C88E0"
      />
      <path
        d="m1054.966 838.172-198.744-27.571c-5.744-.766-9.19-5.744-8.424-11.105l39.059-281.842c.766-5.361 5.744-9.19 11.105-8.425l199.127 27.955c5.362.766 9.191 5.744 8.425 11.105l-39.442 281.459c-.766 5.361-5.362 9.19-11.106 8.424Z"
        fill="#2A144C"
      />
      <path
        d="m1056.881 819.408-196.83-27.188 37.528-269.971 197.213 27.189-37.911 269.97Z"
        fill="#70A3F6"
      />
      <path
        d="m1030.458 812.515-170.024-23.359 37.145-268.821 190.703 26.422-34.464 248.143c-9.191 6.893-14.169 10.723-23.36 17.615Z"
        fill="#FFF"
      />
      <path
        d="m1034.288 546.757-78.502-10.722c-4.596-.766-7.659-4.595-6.893-9.19l1.149-8.042c.766-4.212 4.595-7.276 8.807-6.893l78.885 11.105c4.212.383 7.276 4.595 6.51 8.808l-1.149 8.424c-.383 4.213-4.595 7.276-8.807 6.51Z"
        fill="#F1C168"
      />
      <path
        d="m1029.31 812.515 2.68-20.678 20.679 2.68-19.53 18.381-3.829-.383ZM1023.183 555.948l-59.356-8.425 2.681-19.147 59.355 8.425-2.68 19.147Z"
        fill="#4C88E0"
      />
      <path
        d="m1041.946 547.906-94.202-13.02 2.298-16.083c.766-4.212 4.595-7.276 8.807-6.893l78.885 11.105c4.212.383 7.276 4.595 6.51 8.808l-2.298 16.083Z"
        fill="#022E6A"
      />
      <path
        d="M937.405 604.198c-5.361-.766-9.191-5.744-8.425-11.105.766-5.362 5.744-9.191 11.105-8.425 5.361.766 9.191 5.744 8.425 11.105-.766 5.361-5.744 9.191-11.105 8.425ZM929.363 665.468c-5.361-.766-9.19-5.744-8.425-11.106.766-5.361 5.744-9.19 11.106-8.424 5.361.766 9.19 5.744 8.424 11.105-.766 5.361-5.744 9.191-11.105 8.425ZM1007.482 593.858l-24.891-3.829c-1.149 0-1.914-1.149-1.914-2.298.383-1.148 1.531-2.297 2.68-1.914l24.891 3.446c1.149 0 2.298 1.149 1.915 2.681 0 1.149-1.149 1.914-2.681 1.914ZM1059.945 601.134l-42.124-6.127c-1.148 0-1.914-1.149-1.914-2.297 0-1.532 1.149-2.298 2.68-1.915l42.123 5.744c1.149 0 2.298 1.149 1.915 2.681 0 1.148-1.149 1.914-2.68 1.914Z"
        fill="#4C88E0"
      />
      <mask id="f" x="-200%" y="-200%" width="400%" height="400%">
        <rect
          x="-200%"
          y="-200%"
          width="400%"
          height="400%"
          style={{
            fill: "#fff",
          }}
        />
        <path d="m980.677 608.41 76.204 10.339" />
      </mask>
      <path
        mask="url(#f)"
        vectorEffect="non-scaling-stroke"
        strokeWidth={0.8}
        stroke="#70A3F6"
        d="m980.677 608.41 76.204 10.339"
      />
      <mask id="g" x="-200%" y="-200%" width="400%" height="400%">
        <rect
          x="-200%"
          y="-200%"
          width="400%"
          height="400%"
          style={{
            fill: "#fff",
          }}
        />
        <path d="m978.762 621.813 76.204 10.339" />
      </mask>
      <path
        mask="url(#g)"
        vectorEffect="non-scaling-stroke"
        strokeWidth={0.8}
        stroke="#70A3F6"
        d="m978.762 621.813 76.204 10.339"
      />
      <path
        d="m929.746 670.446-30.252-4.212c-.766 0-1.149-.766-1.149-1.532s.766-1.149 1.532-1.149l30.252 4.212c.766 0 1.149.766 1.149 1.532s-.766 1.149-1.532 1.149Z"
        fill="#FFF"
      />
      <path
        d="m984.506 706.442-19.147-2.681c-.766 0-1.149-.383-.766-1.148v-.383c0-.766.383-1.149 1.149-1.149l19.147 2.68c.383 0 .766.766.766 1.149v.766c-.383.383-.766 1.149-1.149.766ZM982.974 717.164l-19.147-2.68c-.383 0-.766-.766-.766-1.149v-.766c0-.383.766-1.149 1.149-.766l19.147 2.681c.383 0 .766.383.766 1.148v.383c0 .766-.766 1.149-1.149 1.149Z"
        fill="#B688FF"
      />
      <path
        d="m927.831 683.849-30.252-4.213c-.766 0-1.149-.766-1.149-1.531 0-.766.766-1.149 1.532-1.149l30.252 4.212c.766 0 1.149.766 1.149 1.532s-.766 1.532-1.532 1.149ZM1013.226 696.103l-18.764-2.681c-.383 0-.766-.766-.766-1.149v-.766c0-.766.766-1.148 1.149-.766l18.764 2.298c.766.383 1.149.766 1.149 1.532v.383c-.383.766-.766 1.149-1.532 1.149ZM925.917 697.634l-30.252-4.212c-.766-.383-1.149-1.149-1.149-1.532v-.383c.383-.766.766-1.148 1.532-1.148l30.252 4.212c.765.383 1.531.766 1.148 1.532v.383c0 .382-.766 1.148-1.531 1.148ZM924.002 711.037l-30.252-4.212c-.766-.383-1.149-.766-1.149-1.532v-.383c.383-.383.766-1.149 1.532-.766l30.252 4.213c.766 0 1.532.765 1.149 1.148v.383c0 .766-.766 1.149-1.532 1.149Z"
        fill="#FFF"
      />
      <path
        d="M719.514 728.652c-19.53.766-30.635-15.7-31.784-38.293l21.061-111.435 103.393 58.206c-6.127 9.957-.765 22.977 10.723 25.274l3.829.766 137.474 35.996c73.907-.766 57.441-9.956 83.098-15.7q9.573 1.531 9.19 4.595c0 2.68-32.167 24.508-29.869 26.04 2.681 1.148 73.524 20.678 70.077 27.188-3.063 6.51-46.335-4.212-48.25-1.149-1.531 3.447 45.187 9.191 44.038 15.318-1.149 6.51-47.867-1.149-47.484 1.914.383 3.064 44.421 6.127 43.272 11.106-1.532 4.595-48.25-1.532-50.165.383-1.915 1.531 42.123 4.595 43.272 10.722.766 4.595-41.357 1.915-54.377-.766-45.952-8.808-70.46-19.147-81.183-22.593l-226.315-27.572Z"
        fill="#EE9387"
      />
      <path
        d="M935.49 275.255q46.335-10.722 54.377-10.339 12.254.383 39.826 3.829c1.148 5.744-3.447 62.419-29.87 71.226q-17.232 5.361-63.95-18.764l-.383-45.952Z"
        fill="#FFF"
      />
      <mask id="h" x="-200%" y="-200%" width="400%" height="400%">
        <rect
          x="-200%"
          y="-200%"
          width="400%"
          height="400%"
          style={{
            fill: "#fff",
          }}
        />
        <path d="m901.026 241.94 45.569 40.591" />
      </mask>
      <path
        mask="url(#h)"
        vectorEffect="non-scaling-stroke"
        strokeWidth={1}
        stroke="#FFF"
        d="m901.026 241.94 45.569 40.591"
      />
      <mask id="i" x="-200%" y="-200%" width="400%" height="400%">
        <rect
          x="-200%"
          y="-200%"
          width="400%"
          height="400%"
          style={{
            fill: "#fff",
          }}
        />
        <path d="m889.921 287.509 59.738 32.55" />
      </mask>
      <path
        mask="url(#i)"
        vectorEffect="non-scaling-stroke"
        strokeWidth={1}
        stroke="#FFF"
        d="m889.921 287.509 59.738 32.55"
      />
      <path
        d="M858.52 674.658c-3.447-5.744 28.337-10.339 20.295-11.871-8.041-1.532-44.803 1.532-45.186-4.978-.383-5.361 41.357-3.829 42.506-8.425 1.149-4.595-47.101 0-48.633-4.212-4.978-11.871 50.165-7.276 50.93-15.317.766 1.148-47.484 1.148-44.803-7.659 1.149-4.213 37.528-4.978 71.992-4.978 2.681 0 3.446-3.064 1.532-4.596-11.488-9.19-24.508-18.764-14.935-21.444q62.802 14.934 75.822 26.805v.383l113.732-7.275c7.276 0 17.615 4.595 15.317-2.681 4.596-24.125 22.211-49.399 26.423-44.804 2.681 2.681 15.318 22.977 28.72 45.187 21.445 34.464-2.297 79.268-42.889 81.183q-70.843 3.063-149.345-17.998v-.383c-16.083 4.212-98.415 8.041-101.478 3.063Z"
        fill="#EE9387"
      />
      <path
        d="M374.278 803a10.7 10.7 0 0 1-7.585-3.143L222.564 655.725a10.713 10.713 0 0 1 0-15.169 10.716 10.716 0 0 1 15.17 0l144.129 144.131a10.714 10.714 0 0 1 0 15.17 10.658 10.658 0 0 1-7.585 3.143Z"
        fill="#FF6E6E"
      />
      <path
        d="M227.632 805.49a10.696 10.696 0 0 1-7.585-3.143 10.714 10.714 0 0 1 0-15.17l144.129-144.131a10.716 10.716 0 0 1 15.17 0 10.713 10.713 0 0 1 0 15.17L235.217 802.347a10.678 10.678 0 0 1-7.585 3.143Z"
        fill="#FF6E6E"
      />
    </g>
  </svg>
);

export default SvgComponent;
